//#region IMPORT
import React, { useMemo } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './RIS_CUSTOM_ColumnDefs';

import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {
  Unstable_Grid2 as Grid,
  Box,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { AuthButton } from '../../../../Components/MUIs';
import { useDispatch } from 'react-redux';
import {
  setSearchText,
  setStartDate,
  setEndDate,
} from '../../../../Reducer/SearchReducer';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import FileUploadDialogNoGrid from '../../../../Components/FileUploadDialog/FileUploadDialogNoGrid';
//#endregion
function RIS_CUSTOM(props) {
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  //#region 변수
  /* eslint-disable react-hooks/exhaustive-deps */
  const columnDefs1 = useMemo(
    () => getColumnDefs1(props),
    [
      props.DeleteNewRow1,
      props.RestoreRow1,
      props.gridRef1,
      props.rowData1,
      props.selectedRowNosRef1,
      props.lastCheckedIndexRef1,
      props.handleRowSelection1,
      props.SearchLogic2,
      props.onOpenRegulation,
      props.onExecuteRiskAssessment,
    ]
  );
  /* eslint-enable react-hooks/exhaustive-deps */

  //#endregion

  const handleAddRow1 = () => {
    // +(추가) 클릭 시 규정 작성 화면으로 이동
    if (props.onAddClick) {
      props.onAddClick();
      return;
    }
    props.ResetLogic1?.();
  };
  const handleDeleteRows1 = () => {
    if (!props.validateSelection()) return;

    const newRowExists = props.selectedRowData1.some(
      (row) => row.newYn === 'Y'
    );

    if (!newRowExists) {
      props.MarkedForDeletion1(props.selectedRowData1);
    } else {
      props.NewYnErrorMsg();
    }
  };

  const handleRefresh1 = () => {
    if (!props.validateSelection()) return;
    // props.SearchLogic1();
  };

  const handleCellClick1 = (e) => {
    const gridApi = props.gridRef1?.current?.api;
    if (!gridApi) return;

    const clickedRowIndex = e.rowIndex;
    const isCheckboxClick = e.event?.target?.type === 'checkbox';

    if (!isCheckboxClick) {
      gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
      gridApi.setFocusedCell(clickedRowIndex, 'rsNm');

      if (props.handleRowSelection1) {
        const copied = JSON.parse(JSON.stringify(e.data));
        props.handleRowSelection1([copied]);
      }

      gridApi.getDisplayedRowAtIndex(clickedRowIndex)?.setSelected(true, false);
    }
  };

  const handleSelectionChanged1 = () => {
    const gridApi = props.gridRef1?.current?.api;
    if (!gridApi) return;

    const selectedNodes = gridApi.getSelectedNodes();
    const selectedData = selectedNodes.map((n) => n.data);
    if (props.selectedRowNosRef1?.current) {
      props.selectedRowNosRef1.current = new Set(selectedData.map((r) => r.no));
    }

    if (props.setSelectedRowData1) {
      props.setSelectedRowData1(selectedData);
    }
  };

  const handleCellValueChanged1 = (e) => {
    e.data.editYn = 'Y';

    const key = e.data.no;
    props.setChangedRowData1?.((prev) => {
      const filtered = prev.filter((row) => row.no !== key);
      return [...filtered, { ...e.data }];
    });
  };

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="RiskEvaluation"
          saveYn="Y"
          printYn="N"
          saveClick={() => {
            void props.SaveLogic1?.();
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
            props.gridRef1.current.api.setQuickFilter(e);
          }}
          conditions={[
            {
              type: 'datePicker',
              title: '기간',
              name: '조회일자(시작)',
              value: dayjs(searchInfo.startDate),
              onChange: (date) => {
                dispatch(setStartDate(dayjs(date).format('YYYY-MM-DD')));
                if (props.value === 0) {
                  props.setSearchClick1?.(true);
                } else {
                  props.setSearchClick2?.(true);
                }
              },
              currentLocale: 'ko',
            },
            {
              type: 'datePicker',
              title: '조회일자(끝)',
              name: '조회일자(끝)',
              value: dayjs(searchInfo.endDate),
              onChange: (date) => {
                dispatch(setEndDate(dayjs(date).format('YYYY-MM-DD')));
                if (props.value === 0) {
                  props.setSearchClick1?.(true);
                } else {
                  props.setSearchClick2?.(true);
                }
              },
              currentLocale: 'ko',
            },
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo.coList,
                    value: searchInfo.coCd,
                    onChange: async (e) => {
                      await props.handleCoChange(e);
                      if (props.value === 0) {
                        props.setSearchClick1?.(true);
                      } else {
                        props.setSearchClick2?.(true);
                      }
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList,
              value: searchInfo.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);
                if (props.value === 0) {
                  props.setSearchClick1?.(true);
                } else {
                  props.setSearchClick2?.(true);
                }
              },
            },
          ]}
          placeholder="검색"
          grids={
            <>
              <Box
                sx={{
                  mb: 2,
                  borderRadius: 1.5,
                  px: 2,
                  py: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  boxShadow: props.regulationCompleted
                    ? '0 0 0 1px rgba(46, 125, 50, 0.3)'
                    : '0 0 0 1px rgba(211, 47, 47, 0.25)',
                  bgcolor: props.regulationCompleted ? '#e8f5e9' : '#ffebee',
                }}
              >
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: props.regulationCompleted
                        ? '#c8e6c9'
                        : '#ffcdd2',
                      color: props.regulationCompleted ? '#1b5e20' : '#b71c1c',
                      flexShrink: 0,
                    }}
                  >
                    <WarningAmberIcon
                      fontSize="small"
                      sx={{
                        color: props.regulationCompleted
                          ? '#2e7d32'
                          : '#b71c1c',
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 700,
                        color: props.regulationCompleted
                          ? '#2e7d32'
                          : '#c62828',
                      }}
                    >
                      {props.regulationCompleted
                        ? '실시규정 입력 완료'
                        : '실시규정 상태 확인 필요'}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mt: 0.25, color: '#555' }}
                    >
                      {props.regulationCompleted
                        ? '현재 선택한 사업장에 대해 등록된 실시규정을 확인하거나 수정할 수 있습니다.'
                        : '현재 선택한 사업장에 대해 실시규정 등록이 필요합니다. 규정을 먼저 입력한 후 평가를 진행해주세요.'}
                    </Typography>
                  </Box>
                </Stack>
                <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                  {props.regulationCompleted ? (
                    <>
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={props.onPreviewRegulation}
                        sx={{
                          minWidth: 120,
                          fontWeight: 800,
                          borderColor: '#1976d2',
                          borderWidth: 1,
                          borderRadius: 1.5,
                          height: 32,
                          textTransform: 'none',
                          px: 1.75,
                          color: '#1976d2',
                          backgroundColor: '#e3f2fd',
                          '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#dbeafe',
                          },
                        }}
                      >
                        규정 미리보기
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={props.onEditRegulation}
                        sx={{
                          minWidth: 120,
                          fontWeight: 800,
                          borderRadius: 1.5,
                          height: 32,
                          textTransform: 'none',
                          px: 1.75,
                          backgroundColor: '#1976d2',
                          color: '#fff',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#1565c0',
                            boxShadow: 'none',
                          },
                        }}
                      >
                        규정 수정하기
                      </Button>
                    </>
                  ) : (
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={props.onAddRegulation}
                      sx={{ minWidth: 120, fontWeight: 600 }}
                    >
                      규정 등록하기
                    </Button>
                  )}
                </Box>
              </Box>
              <BusinessGridCommon
                getRowId={(params) => params.data.no}
                title1={'위험성평가 사전준비'}
                addYn1={'Y'}
                deleteYn={'Y'}
                fileUploadYn1="N"
                fileDownloadYn1="N"
                addClick1={handleAddRow1}
                deleteClick1={handleDeleteRows1}
                refreshClick1={handleRefresh1}
                gridRef={props.gridRef1}
                columnDefs={columnDefs1}
                rowData={props.rowData1 || []}
                editable={true}
                rowSelection="multiple"
                rowMultiSelectWithClick={true}
                setSelectedRowData={props.setSelectedRowData1}
                setChangedRowData={props.setChangedRowData1}
                onCellClicked={handleCellClick1}
                onSelectionChanged={handleSelectionChanged1}
                onCellValueChanged={handleCellValueChanged1}
              />
            </>
          }
        />
      </Grid>

      {props.fileModalToggle && (
        <FileUploadDialogNoGrid
          open={props.fileModalToggle}
          onClose={() => props.setFileModalToggle(false)}
          SaveLogicPreview={props.SaveLogicPreview}
          onUploaded={props.onUploadedRegulationFile}
          onSave={(file) => props.SaveRegulationLogic1?.(file)}
          initialExistingFile={props.initialExistingFile}
        />
      )}
    </Grid>
  );
}

export default RIS_CUSTOM;
